'use strict';

import EmptyRouterView from '../../../app/views/EmptyRouterView.vue';
import StandingView from '../views/StandingView.vue';
import StandingManageView from '../views/StandingManageView.vue';
// import { standingManageEventRoutes } from '../../event/routes/event-routes';
// import { standingManageSettingRoutes } from '../../setting/routes/setting-routes';
// import { standingManageSecurityRoutes } from '../../security/routes/security-routes';

// Standing routes
let standingChildRoutes = [
  {
    path: '',
    name: 'standing.detail',
    props: true,
    component: () => import('../views/StandingDetailView.vue'),
  },
  {
    path: 'edit',
    name: 'standing.edit',
    props: true,
    component: () => import('../views/StandingDetailView.vue'),
  },
];

// Manage standing routes
let manageChildRoutes = [
  {
    path: '',
    name: 'standing.manage.detail',
    props: true,
    component: () => import('../views/StandingManageHomeView.vue'),
  },
  {
    path: 'edit',
    name: 'standing.manage.edit',
    props: true,
    component: () => import('../views/ManageStandingEditView.vue'),
  },
];
manageChildRoutes = manageChildRoutes
  .concat
  // standingManageEventRoutes,
  // standingManageSettingRoutes,
  // standingManageSecurityRoutes,
  ();

export const standingRoutes = [
  {
    path: '/standings',
    component: EmptyRouterView,
    children: [
      {
        path: '',
        name: 'standing.list',
        component: () => import('../views/StandingListView.vue'),
      },
      {
        path: 'add',
        name: 'standing.add',
        component: () => import('../views/StandingAddView.vue'),
      },
      {
        path: ':standingId/manage',
        component: StandingManageView,
        props: true,
        meta: {
          layout: 'ManagementLayout',
        },
        children: manageChildRoutes,
      },
      {
        path: ':standingId',
        component: StandingView,
        props: true,
        children: standingChildRoutes,
      },
    ],
  },
];
